/// Store
import getToolsForElement from "component/molecules/viewport/toolStates/getToolsForElement.js";
import getToolsWithDataForElement from "component/molecules/viewport/toolStates/getToolsWithDataForElement.js";
import { getters } from "component/molecules/viewport/toolStates/store.js";
/// Dialog
import FloatMessageBox from "core/messageBoxController";
import RequestDeleteToolState from "./RequestDeleteToolState";
/// Constants
import Constants from "constants/index";
import Config from "config";

const requestDisplayData = (
  viewportIndex: number,
  enabledElement: any,
  metadataID: any,
  displayFrameIdx: number,
  isBatchMode: boolean
) => {
  RequestDeleteToolState(enabledElement.element);
  // 초기화 viewport 출력 영역 초기화

  Config.rootStore.gridLayoutStore.setSeriesMetadataAtDCMView(
    viewportIndex,
    metadataID,
    displayFrameIdx,
    isBatchMode
  );
  if (
    Config.rootStore.synchronizationStore.isSupportedSynchronizationOnActive() ===
    true
  ) {
    Config.rootStore.synchronizationStore.reactiveSyncState();
  } else {
    Config.rootStore.synchronizationStore.disableSyncState();
  }
  /// 특정 viewport 를 활성화 상태로 변경한다.
  //Config.rootStore.gridLayoutStore.setActiveDCMViewIndex(viewportIndex);
  Config.rootStore.gridLayoutStore.toggleActiveOnlyOneDCMView(viewportIndex);
  Config.rootStore.seriesListStore.setActiveSeriesItem(metadataID);
};

/**
 *
 *
 * @param {number} viewportIndex
 * @param {*} data
 */
const readyRequestDisplayData = (
  viewportIndex: number,
  enabledElement: any,
  metadataID: any,
  displayFrameIdx: number,
  isBatchMode: boolean
) => {
  ///
  /// 0. viewport에 데이터가 있는지 확인
  ///
  if (enabledElement.image === null || enabledElement.image === undefined) {
    // 데이터 대체
    requestDisplayData(
      viewportIndex,
      enabledElement,
      metadataID,
      displayFrameIdx,
      isBatchMode
    );
    return;
  }

  ///
  /// 1. 대상 DCMView(viewport)에 작업된 사항이 있는지 체크
  ///
  let tools = getToolsForElement(enabledElement.element, getters.mouseTools());
  tools = getToolsWithDataForElement(enabledElement.element, tools);

  ///
  /// 2. 작업한 사항이 있다면, 대화상자를 띄워서 다른 데이터로 출력할 것인지 질의
  /// 그렇지 않다면, 데이터 출력
  ///
  if (tools.length > 0) {
    // 작업한 사항이 있다면, 대화상자를 출력하고, 해당 데이터를 출력할 것인지 질의
    /// 교체 상황 발생
    const parameters = {
      title: "Warning",
      message: Constants.Strings.DialogMessage.ConfirmChangeDataOnDCMView,
      buttonType: "YESNO",
      hasCloseButton: false,
      //hasTodayOffButton: true,
      hasTodayOffButton: false,
      handleYesClick: function () {
        requestDisplayData(
          viewportIndex,
          enabledElement,
          metadataID,
          displayFrameIdx,
          isBatchMode
        );
      },
    };
    FloatMessageBox(parameters);
  } else {
    // 데이터 대체
    requestDisplayData(
      viewportIndex,
      enabledElement,
      metadataID,
      displayFrameIdx,
      isBatchMode
    );
  }
};

/**
 *
 *
 * @param {number} viewportIndex
 * @param {*} data
 */
const requestChangeDisplayData = (
  viewportIndex: number,
  enabledElement: any,
  metadataID: any,
  displayFrameIdx: number,
  isBatchMode: boolean
) => {
  // 데이터 대체
  requestDisplayData(
    viewportIndex,
    enabledElement,
    metadataID,
    displayFrameIdx,
    isBatchMode
  );
};

export default requestChangeDisplayData;
